import { CallcenterSocketManager } from "@callcenter/api"
import type { Observable } from "rxjs"

import type { KycStatus } from "../shared/types"

export type KycChannelStreamData = { status: KycStatus }

export class KycChannel extends CallcenterSocketManager<void, KycChannelStreamData> {
  constructor() {
    super("KycChannel" as never, undefined, false)
  }
  get onUpdate(): Observable<KycChannelStreamData> {
    return this.listen()
  }
}
